import _Replay from "@mui/icons-material/Replay";
import React from 'react';
import styled from 'styled-components';
import { COLORS, Typography } from '@fupa/fupa-uikit';
import { Button } from '@mui/material';
import { MessageWrapper } from 'app/components/district/commonStyles';
const Link = styled.a.withConfig({
  componentId: "sc-7fdg7p-0"
})(["color:", ";"], COLORS.fupaSecondary);
export default function InfiniteScrollErrorMessage(_ref) {
  let {
    onRetry,
    entityName = 'Meldungen'
  } = _ref;
  return /*#__PURE__*/React.createElement(MessageWrapper, {
    "data-sentry-element": "MessageWrapper",
    "data-sentry-component": "InfiniteScrollErrorMessage",
    "data-sentry-source-file": "InfiniteScrollErrorMessage.tsx"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    "data-sentry-element": "Typography",
    "data-sentry-source-file": "InfiniteScrollErrorMessage.tsx"
  }, "Aufgrund eines tempor\xE4ren Fehlers konnten keine weiteren ", entityName, " bezogen werden. Versuche es bitte erneut. Sollte das Problem weiterhin auftreten, wende dich bitte an unseren", ' ', /*#__PURE__*/React.createElement(Link, {
    href: "https://support.fupa.net/support/tickets/new",
    "data-sentry-element": "Link",
    "data-sentry-source-file": "InfiniteScrollErrorMessage.tsx"
  }, "Support"), "."), /*#__PURE__*/React.createElement(Button, {
    variant: "contained",
    color: "inherit",
    sx: {
      color: COLORS.fupaSecondary,
      backgroundColor: COLORS.lightestGrey
    },
    startIcon: /*#__PURE__*/React.createElement(_Replay, {
      color: "secondary"
    }),
    onClick: onRetry,
    "data-sentry-element": "Button",
    "data-sentry-source-file": "InfiniteScrollErrorMessage.tsx"
  }, "Erneut versuchen"));
}